import { render, staticRenderFns } from "./ComplaintsTableHeader.vue?vue&type=template&id=ecbee06a"
import script from "./ComplaintsTableHeader.vue?vue&type=script&lang=js"
export * from "./ComplaintsTableHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports